module.exports = __webpack_public_path__ + "static/img/news_real_time_one.e088ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/news_real_time_one.png
// module id = st41
// module chunks = 1